// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__M-FUL","rotate":"loader_rotate__PZK3t"};